<template>
  <el-dialog
    append-to-body
    width="700px"
    title="查看详情"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-table :data="tableData" style="width: 100%" v-loading="loading">
      <el-table-column type="index" width="50" label="序号"> </el-table-column>
      <el-table-column prop="merchant_name" label="客户名称" width="180">
      </el-table-column>
      <el-table-column prop="num" label="交易次数"> </el-table-column>
      <el-table-column prop="amount" label="交易金额" width="120">
        <template #default="scope">￥{{ scope.row.amount }}</template>
      </el-table-column>
      <el-table-column prop="time" label="最新下单时间" width="160">
      </el-table-column>
    </el-table>
    <template #footer>
      <el-row type="flex" justify="center">
        <el-button @click="toggle(false)">关闭</el-button>
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      visible: false,
      loading: false,
      tableData: [],
    };
  },
  methods: {
    reset() {
      this.tableData = [];
      this.visible = false;
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    getDetail(row) {
      this.loading = true;
      this.$http
        .get("/admin/salesman/info", {
          params: { salesman_id: row.id, page: 1, count: 9999 },
        })
        .then((res) => {
          if (res.code == 1) {
            this.tableData = res.data.list;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.addPerson__wrap {
  @include position($t: 0, $r: 0, $b: 0, $l: 0);
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.idPhoto .avatar {
  width: 100% !important;
}
.idPhoto .avatar-uploader-icon {
  width: 260px !important;
  height: 170px !important;
  line-height: 170px !important;
  border: 1px dashed #d9d9d9;
}
.onBtn-large {
  display: flex;
  justify-content: center;
}
</style>
